import noticeError from "./notice-error";
import sdkProvider from "./sdk-provider";

export async function fetchConfig(requestHelper) {
  const identity = await sdkProvider("identity");
  const authHeader = await identity.getAuthHeader();
  try {
    const response = await requestHelper.get({
      url: "/api/marketing/student/v1/config",
      headers: {
        Authorization: authHeader,
      },
    });

    return response.data;
  } catch (error) {
    noticeError(error);
  }
}
